import type { GraphQLFormattedError } from "@aws-amplify/data-schema-types";

export function throwFirstError(errors?: GraphQLFormattedError[]): void {
  if (errors && errors.length) {
    console.error(errors);
    throw errors[0];
  }
}
